import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useApi } from "@/lib/api";

const Ctx = createContext(null);

export function MemberProvider({ children }) {
  const api = useApi();
  const [state, setState] = useState({ loading: true });

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/me");
      setState({ loading: false, ...data });
    } catch {
      setState({ loading: false, error: true });
    }
  }, [api]);

  useEffect(() => {
    reload();
  }, [reload]);

  const role = state.member?.role;
  const value = { ...state, reload, isManager: role === "owner" || role === "manager", isOwner: role === "owner" };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useMember = () => useContext(Ctx);
